/**
 * Cell type enum for RisaCustomTable.
 */
export enum TableCellType {
  STRING = "string",
  MULTILINE_CELL_WITH_LEFT_BORDER = "multiline-cell-with-left-border",
  TAGS_WITH_DROP_DOWN = "tags-with-drop-down",
  CLICKABLE_BADGE_WITH_ON_CLICK = "clickable-badge-with-on-click",
  TAG_CELL = "tag-cell",
  TAG_WITH_OVERFLOW = "tag-with-overflow",
  MULTILINE_CELL_WITH_COPY = "multiline-cell-with-copy",
  ELIGIBILITY_ACTION_ITEMS = "eligibility-action-items",
  DIAGNOSIS_WITH_OVERFLOW = "diagnosis-with-overflow",
  STAGE_WITH_OVERFLOW = "stage-with-overflow",
  CUSTOM_RENDER = "custom-render",
}

/**
 * Column descriptor used by the table renderer.
 */
export interface TableHeader {
  label: string;
  key: string;
  order: number;
  width: number;
  sortable?: boolean;
  filterable?: boolean;
  sectionSearch?: boolean;
  type: TableCellType;
  subKey?: string;
  sortField?: string;
}

/**
 * Pre-computed cell payload for a single table cell.
 */
export interface CellData {
  type: TableCellType;
  value: any;
  width: number;
  header?: string;
  rowData?: any;
  fieldKey?: string;
  originalRowData?: any;
}
